import { Filters } from "@/types/filters";

export function createDefaultFilters(): Partial<Filters> {
	// Return truly empty state - no default values that could leak to URL/backend
	// All form defaults should be handled locally in components
	return {
		// empty arrays
		locations: [],
		documents: [],
		facing: [],
		spaces: [],
		waterSources: [],
		levelType: [],
		amenities: [],
		plotFacing: [],

		// Range values with 0-0 defaults for display (not sent to backend until dirty)
		bedrooms: { min: 0, max: 0 },
		budget: { min: 0, max: 0 },
		rentalValue: { min: 0, max: 0 },
		floors: { min: 0, max: 0 },

		// Number defaults for display
		bathroomsMin: 0,
		builtupAreaMin: 0,
		plotAreaMin: 0,
		balconiesMin: 0,
		parkingsMin: 0,

		// String defaults
		propertyType: "",
		furnishing: "",
		status: "",
		maxAge: "",
		possession: "",
	};
}
